import { render, staticRenderFns } from "./ApprovisionnementsEntiteNews.vue?vue&type=template&id=cc045cc6&"
import script from "./ApprovisionnementsEntiteNews.vue?vue&type=script&lang=js&"
export * from "./ApprovisionnementsEntiteNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports